
import { insureDetailAllExport, PlanStatisticsDto, planTermsDataDto, replaceCountInfoDto } from '@/api/long-insure'
import { checkCompanyInsureStatusApi, insureEnsurePlanDetailApi, insureEnsureReplaceCountApi, queryPageListByPlanApi, queryRecordPageListApi, queryStatisticsDetailApi, revokeEnsureApi, getPlanIsRead, getPlanListData, addReadRecord, onekeyRenewalMonthNotifyApi, exportRecordStaffApi, getSpecialNoticeApi } from '@/api/long-insure-new'
import { defineComponent } from 'vue'
import * as echarts from 'echarts'
import AlertBox from '@/components/alert-box.vue'
import tabCapsule from '@/components/tab-capsule.vue'
import { dateFormat, confirm, isWeixin, downloadFileAndChangeName, downloadBlobFile } from '@/utils/util'
import exportButton from '../components/export-button.vue'
import dayjs from 'dayjs'
import { exportCompanyBillList } from '@/api/long-insure'
import { downLoadBlob } from '../utils/util'
import { ElMessage } from 'element-plus'
import user from '@/utils/user'
import { sdLimitList } from '../utils/config'
import InsureSpecialAgreement from '@/components/dialog/insure-special-agreement.vue'

export default defineComponent({
  name: 'LongInsureDetail',
  components: {
    AlertBox,
    tabCapsule,
    exportButton,
    InsureSpecialAgreement
  },
  data() {
    return {
      insurCompany: '',
      customerDate: '',
      countDate: '',
      searchName: '',
      tioInfo: {} as any,
      countPageSize: 5,
      countPageNum: 1,
      countTotal: 0,
      countList: [],
      personnelPageSize: 5,
      personnelPageNum: 1,
      personnelTotal: 100,
      personnelList: [],
      personneDate: '',
      isExportAllPopup: false,
      exportDate: '',
      exportType: '1',
      statisticsData: {} as PlanStatisticsDto,
      statisticsTab: 0,
      canInsureRenewal: false,
      isGoFluctuate: false,
      payTypeList: ['全部', '保障中', '待生效', '不在保'],
      PlanType2: false,
      payType: '',
      policyStatusNumber: '' as string | number,
      isUp: false,
      form: {
        filterMonth: dayjs().format('YYYY-MM')
      },
      planIsRead: false, // 是否显示 查看方案条款 按钮
      showPlanNotice: false, // 控制 方案条款 通知
      showReadButton: false, // 控制我已知晓 按钮
      countDownTime: false, // 倒计时
      countdown: 5, // 倒计时
      timer: null, // 倒计时
      planTermsData: {
        id: -1
      } as planTermsDataDto,
      replaceCountInfo: {} as replaceCountInfoDto,
      showReplaceCount: false,
      isSpecialSd: false,
      showNotice: false, // 控制 保险投保提醒 弹框
      specialNoticeContent: '' // 保险投保提醒内容
      // planTermsData: {  }
    }
  },

  watch: {
    showNotice(newVal: boolean, oldVal: boolean) {
      // 弹框由展示变为关闭，代表用户已点击"我已知晓"，继续执行加保逻辑
      if (oldVal && !newVal) {
        this.goInsureAdd()
      }
    }
  },

  async created() {
    this.customerDate = dateFormat('YYYY-mm', new Date())
    await this.getInsureDetailInfo()
    this.getInsureDetailAdditionList()
    this.getInsureDetailPersonnelList()
    // 获取统计数据
    await this.getStatistics()
    this.onStatisticsTab(0)
    this.getRenewalMonthNotify()
    this.getSpecialNotice()

    this.isSpecialSd = sdLimitList.includes(this.tioInfo.code)

    // this.onGetPlanIsRead()
    // this.onGetPlanListData()
  },
  methods: {
    onChangeDate(e: any) {
      console.log(e, 'eeeeeeee')
    },

    onCancel() {
      this.isUp = false
      this.form.filterMonth = dayjs().format('YYYY-MM')
    },
    async onSure() {
      if (!this.form.filterMonth) {
        ElMessage({
          message: '请选择账单月份',
          type: 'warning'
        })
        return false
      }
      const startDate = dayjs(this.form.filterMonth).startOf('month').format('YYYY-MM-DD')
      const endDate = dayjs(this.form.filterMonth).endOf('month').format('YYYY-MM-DD')
      console.log(this.tioInfo.insureEnsurePlanId, 'insureEnsurePlanId')
      let res = await exportCompanyBillList(
        {
          queryStart: startDate,
          queryEnd: endDate,
          companyPlanId: this.$route.params.id,
          ensurePlanId: this.tioInfo.insureEnsurePlanId
        },
        '/staff'
      )
      downLoadBlob(res, `安心保【${this.form.filterMonth}】人员账单`)
      this.$message.success('导出成功！')
      this.onCancel()
    },
    onShowIdCard() {},

    // 查看当前用户是否需要 弹出 条款通知
    async onGetPlanIsRead() {
      const res = await getPlanIsRead({
        insureCompanyId: this.tioInfo.insureCompanyId
      })

      console.log(res, '查看当前用户是否需要读取对应保司的方案条款')
      // 初次 弹出方案条款 1-true 2-false
      if (res == 1) {
        this.showPlanNotice = true
        this.showReadButton = true
        this.countDownTime = true
        this.planIsRead = true
        this.startCountdown()
      }
    },

    startCountdown() {
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.countDownTime = false
        }
      }, 1000)
    },
    // 获取方案条款信息
    async onGetPlanListData() {
      const data = await getPlanListData({
        insureCompanyId: this.tioInfo.insureCompanyId
      })
      console.log(data, '查询方案条款')
      this.planTermsData = data
    },
    // 点击 方案条款按钮 触发
    onShowPlan() {
      this.showPlanNotice = true
      this.showReadButton = false
    },
    // 关闭方案条款弹框  更新 方案条款 查看记录
    async onCancelPlanNotice() {
      if (this.countDownTime) return

      // 初次才需要 更新
      if (this.showReadButton) {
        await addReadRecord({
          insureCompanyId: this.tioInfo.insureCompanyId,
          insureProgramTermsId: this.planTermsData.id
        })
        this.showPlanNotice = false // 关闭通知
        this.showReadButton = false // 按钮隐藏
      } else {
        this.showPlanNotice = false // 关闭通知
      }
    },

    onLongTermRevoke(id: number) {
      console.log(id)
      if (this.tioInfo.insurePlanType === 2) {
        return
      }
      confirm('', '确定撤回吗？').then(async () => {
        await revokeEnsureApi({
          id: id,
          companyPlanId: Number(this.$route.params.id) as number
        })
        await this.getInsureDetailAdditionList()
        this.$message.success('撤回成功')
      })
    },
    onRenew() {
      if (this.isGoFluctuate) {
        this.$message.error('当前时间段不可操作')
        return
      }
      this.$router.push({
        path: '/long-insure-add-subtract/' + 'add' + '/' + this.$route.params.id + '/' + 'renewal',
        query: {
          code: this.tioInfo.code
        }
      })
    },
    async onInsureAdd() {

      // sd特殊方案需要先续保才能再正常加保
      if (this.canInsureRenewal && this.isSpecialSd) {
        ElMessage.warning('请先续保后再加保')
        return
      }

      if (this.tioInfo.hideAdd) {
        ElMessage.warning('暂时不支持操作加保')
        return
      }

      // 有保险投保提醒内容时，先弹框展示，用户点击"我已知晓"后再继续加保
      if (this.specialNoticeContent) {
        this.showNotice = true
        return
      }

      await this.goInsureAdd()
    },
    // 查询保司的保险投保提醒内容
    async getSpecialNotice() {
      if (!this.tioInfo.insureCompanyId) return
      const result = await getSpecialNoticeApi({
        insureCompanyId: this.tioInfo.insureCompanyId
      })
      this.specialNoticeContent = result?.dictValue || ''
    },
    async goInsureAdd() {
      // getsaasCompanyinfoapi({ planId: this.$route.params.id }).then(async (res: any) => {
      //     console.log(res, 'fshgfgydshug')
      //     if (res.isAreaError && !res.isWhitelist) {
      //         ElMessageBox.confirm(
      //             '非常抱歉，当前方案不支持该（天津）地区投保，请选择“其他方案”继续投保',
      //             '提示',
      //             {
      //                 confirmButtonText: '其他方案',
      //                 cancelButtonText: '取消',
      //                 type: 'warning'
      //             }
      //         )
      //             .then(() => {
      //                 this.$router.back()
      //             })
      //             .catch(() => {
      //                 console.log('取消')
      //             })
      //     } else {
      const result = await checkCompanyInsureStatusApi()
      this.$router.push({
        path: '/long-insure-add-subtract/' + 'add' + '/' + this.$route.params.id
      })
      //     }
      // })
    },
    onInsureSubtract() {
      if (this.tioInfo.insurePlanType === 2) {
        ElMessage.warning('日保单无需减保，默认保障24小时')
        return
      }
      if (this.tioInfo.hideSub) {
        ElMessage.warning('暂时不支持操作减保')
        return
      }
      if (this.isGoFluctuate) {
        this.$message.error('当前时间段不可操作')
        return
      }
      this.$router.push({
        path: '/long-insure-add-subtract/' + 'reduce' + '/' + this.$route.params.id
      })
    },
    // 基本信息
    async getInsureDetailInfo() {
      console.log('this.$route.query', this.$route.query)

      const result = await insureEnsurePlanDetailApi({
        companyPlanId: this.$route.params.id,
        yearMonth: this.customerDate,
        planCode: this.$route.query?.planCode
      })
      console.log(result, result.insureCompanyId, 'jhbhjdgfhjdgfhjkhjkdf基本信息')

      // 显示RB_T保司的保险商品替换名额
      if (result.planCode === 'BX20260326002' || result.planCode === 'SP20260725002') {
        this.showReplaceCount = true
        // 查询RB_T保司的保险商品显示替换名额
        this.onGetReplaceCount()
      }

      this.insurCompany = result.insurCompany
      if (result.code === 'period_002_xdc') {
        const startTime = new Date('2022-09-30 18:00').getTime()
        const endTime = new Date('2022-09-30 24:00').getTime()
        const currentTime = new Date().getTime()
        if (currentTime > startTime && currentTime < endTime) {
          this.isGoFluctuate = true
        }
      }
      if (result.insurePlanType === 1) {
        result.type = 4
      } else if (result.insurePlanType === 0) {
        if (result.effectType === 1) {
          result.type = 3
        }
        if (result.effectType === 2) {
          result.type = 5
        }
      } else if (result.insurePlanType === 2) {
        this.payTypeList = ['全部', '保障中', '不在保']
        this.PlanType2 = true
      }

      console.log(result.insurePlanType == 2, 'result.insurePlanType')

      this.tioInfo = result
    },
    //
    async onGetReplaceCount() {
      const result = await insureEnsureReplaceCountApi({
        companyPlanId: this.$route.params.id,
        companyId: user.companyId || ''
      })
      this.replaceCountInfo = result
    },
    handleCurrentChange(e: string) {
      console.log(e, 'eeeeee标签改变的e是什么')
      this.payType = e
      if (e === '全部') {
        // eslint-disable-next-line no-unused-expressions
        this.policyStatusNumber = ''
      } else if (e === '待生效') {
        // eslint-disable-next-line no-unused-expressions
        this.policyStatusNumber = 0
      } else if (e === '保障中') {
        // eslint-disable-next-line no-unused-expressions
        this.policyStatusNumber = 1
      } else if (e === '不在保') {
        // eslint-disable-next-line no-unused-expressions
        this.policyStatusNumber = 2
      }
      console.log(this.policyStatusNumber, 'policyStatusNumberpolicyStatusNumberpolicyStatusNumberpolicyStatusNumber')
      this.getInsureDetailPersonnelList()
    },
    onStatisticsTab(tab: number) {
      this.statisticsTab = tab
      const element = document.getElementById('echarts') as HTMLElement
      echarts.dispose(element)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} <br/>{c}人  ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: ['60%', '80%'],

            label: {
              position: 'inner',
              formatter: '{b} {c}人'
            },
            data: [] as { value: number; name: string }[]
          }
        ]
      }
      const charts = echarts.init(element)
      if (tab === 0) {
        option.series[0].data = this.statisticsData.occupationGroup.map((item) => ({
          value: item.count,
          name: item.occupationName
        }))
      } else {
        option.series[0].data = this.statisticsData.serveCompanyGroup.map((item) => ({
          value: item.count,
          name: item.serveCompanyName
        }))
      }
      charts.setOption(option)
    },
    async getStatistics() {
      this.statisticsData = await queryStatisticsDetailApi({
        companyPlanId: this.$route.params.id as string,
        policyStatus: ''
      })
    },
    // 加减记录列表
    async getInsureDetailAdditionList() {
      const result = await queryPageListByPlanApi({
        pageSize: this.countPageSize,
        pageNum: this.countPageNum,
        companyPlanId: this.$route.params.id,
        insurStartDate: this.countDate,
        managerName: this.searchName
      })
      this.countList = result.list
      this.countTotal = result.totalCount
    },
    // 改变加减保 每页条数
    countSizeChange() {
      console.log(this.countPageSize, 'countPageSize')
    },
    // 人员列表
    async getInsureDetailPersonnelList() {
      const result = await queryRecordPageListApi({
        pageSize: this.personnelPageSize,
        pageNum: this.personnelPageNum,
        companyPlanId: this.$route.params.id,
        queryStartDate: this.personneDate,
        policyStatus: this.policyStatusNumber
      })
      result.list.map((item: any) => {
        item.encryptionIdCardNo = item.idCardNo.replace(/(.{3})(?:\d+)(.{4})$/, '$1*********$2')
        item.showIdCard = false
      })
      this.personnelList = result.list
      this.personnelTotal = result.totalCount
    },
    // 导出加减保单条数据
    async getInsureDetailAdditionExport(id: string) {
      const res = await exportRecordStaffApi(id)
      console.log(12312, res)
      downloadBlobFile(res)
      // downloadFileAndChangeName(`${process.env.VUE_APP_BASE_URL_NEW}/web/pc/pay/insurePeriodOperateRecord/exportRecordStaff/${id}`, {})
    },
    // 按天或按人导出
    async exportWhole() {
      console.log('导出')
      const result = await insureDetailAllExport({
        queryMonth: this.exportDate,
        queryType: this.exportType,
        companyPlanId: this.$route.params.id
      })
      window.location.href = process.env.VUE_APP_BASE_URL + '/common/download?delete=true&fileName=' + result
      this.$message.success('导出成功！')
      this.isExportAllPopup = false
    },
    async getRenewalMonthNotify() {
      const result = await onekeyRenewalMonthNotifyApi({
        planId: this.$route.params.id
      })
      this.canInsureRenewal = result.canInsureRenewal
      console.log(result, 'result月检测')
    },
    handleExport() {
      //   this.isExportAllPopup = true

      console.log('打开导出弹框')
      this.isUp = true
    }
  }
})
